import EntryGrid from "@/components/EntryGrid";
import Paginate from "@/components/Paginate";
import SplitViewLayout from "@/components/SplitViewLayout";
import { useHeaderContext } from "@/contexts/HeaderContext";
import clsx from "clsx";
import { useEffect } from "react";

const CategoryPage = ({
  category,
  recipes,
  pageCount,
  pageNumber,
  breadcrumbs,
}: {
  pageEntry: {
    uri: string;
    title: string;
  };
  category: {
    uri: string;
    image: {
      url: string;
    }[];
    heading?: string;
    title: string;
    summary?: string;
    seomatic?: object;
  };
  recipes: {
    image: {
      url: string;
    }[];
  }[];
  pageCount: number;
  pageNumber: number;
}) => {
  // Show the header border for this page
  const { setShowBorder } = useHeaderContext();

  useEffect(() => {
    setShowBorder(true);
    return () => setShowBorder(false);
  }, [setShowBorder]);

  // Use the image from category, or the last but one image from the recipes array
  let images = [];

  if (category?.image?.length > 0) {
    images = category.image;
  } else if (recipes.length >= 2) {
    // Get the second to last category that has images
    const categoryWithImages = recipes
      .slice()
      .reverse()
      .find((recipe, index) => index > 0 && recipe.image?.length > 0);

    images = categoryWithImages?.image || [];
  }

  return (
    <div className={clsx("CategoryPage")}>
      <div className={clsx("CategoryPage__header", "border-b")}>
        <SplitViewLayout
          heading={category?.heading || category?.title || "Category"}
          introduction={category?.summary || "No category summary."}
          images={images}
          breadcrumbs={breadcrumbs}
        />
      </div>
      {recipes?.length > 0 && (
        <div className={clsx("border-b px-6 py-6 lg:px-12 lg:py-12")}>
          <EntryGrid entries={recipes} />
        </div>
      )}
      {recipes?.length === 0 && (
        <div className={clsx("px-6 py-6 lg:px-12 lg:py-12")}>
          <div className={clsx("text-center font-body text-sm")}>
            There aren&apos;t any recipes tagged as &ldquo;{category.title}
            &rdquo; yet.
          </div>
        </div>
      )}
      {pageCount > 1 && (
        <Paginate
          pageCount={pageCount}
          activePage={pageNumber}
          baseUri={`/${category.uri}`}
        />
      )}
    </div>
  );
};

export default CategoryPage;
